export const aboutLinks = [
  { id: 1, link: 'Main Skills' },
  { id: 2, link: 'Experience' },
  { id: 3, link: 'Education & Certificate' },
];

export const aboutDetails = [
  [
    {
      id: 1,
      title: 'Front-End Developer',
      extraTitle: '',
      description: 'JavaScript, React, Redux, HTML5, CSS3',
    },
    {
      id: 2,
      title: 'Back-End Developer',
      extraTitle: '',
      description: 'Ruby, Rails, PostgreSQL',
    },
    {
      id: 3,
      title: 'Profession',
      extraTitle: '',
      description: 'Remote-working, Teamwork, Collaboration, Communication & Mentoring',
    },
  ],
  [
    {
      id: 1,
      title: 'Graguate (Full-Stack Web Developer)',
      extraTitle: ' - Microverse',
      description: 'July 2022 - Graguated',
    },
    {
      id: 2,
      title: 'Full Stack Web Developer',
      extraTitle: ' - Self Employed',
      description: 'November 2021 - Current',
    },
  ],
  [
    {
      id: 1,
      title: 'Remote Full Stack Web Development Program, Full-Time',
      extraTitle: ' - Microverse',
      description: '2022',
    },
  ],
];

export default 'Working';
